module.exports = __webpack_public_path__ + "04e67f39205652d677d3af712c939ed5.png";